import { Inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { MxAppInitService } from '../services';

@Injectable()
export class MxHttpHeaderInterceptor implements HttpInterceptor {
  constructor(
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
    private appInitService: MxAppInitService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const apiUrl = this.appInitService.currentConfig?.api?.url;

    if (apiUrl && request.url.startsWith(apiUrl)) {
      request = request.clone({
        setHeaders: {
          'Accept-Language': this.i18NextService.language,
        },
      });
    }
    return next.handle(request);
  }
}
